import * as React from "react";
import {
  Typography,
  Box,
  Button,
  Grid,
  Skeleton,
  Collapse,
  IconButton,
  InputAdornment,
  Tabs,
  Tab,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  centered_flex_box,
  main_button,
  MainInput,
} from "../app/components/Styles";
import { Image, Space, Table, Modal } from "antd";
import PropTypes from "prop-types";
import { Search, Warning } from "@mui/icons-material";
import { useEffect } from "react";
import moment from "moment";
import NewCard from "../app/components/NewCard";
import { getNoShippingOrders, getLateDeliveryOrders, getLateFulfillmentOrders, cancelOrder } from "../app/store/actions/dataActions";
import { getOrderCourierLabel, getOrderTrackingId } from "../app/utils/shippingDisplay";
import { useTranslation } from 'react-i18next';
import SearchFilterBar from '../app/glass/SearchFilterBar';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`action-tabpanel-${index}`}
      aria-labelledby={`action-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export const ActionCenter = ({
  getNoShippingOrders,
  getLateDeliveryOrders,
  getLateFulfillmentOrders,
  cancelOrder,
  user,
  ordersWithoutShipping,
  lateDeliveryOrders,
  lateOrders,
  isLoading,
}) => {
  const navigate = useNavigate();
  const [value, setValue] = React.useState(0);
  const [search, setSearch] = React.useState('');
  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(10);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [selectedOrderId, setSelectedOrderId] = React.useState(null);
  const [isIssuesModalOpen, setIsIssuesModalOpen] = React.useState(false);
  const [selectedOrderIssues, setSelectedOrderIssues] = React.useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useTranslation();

  useEffect(() => {
    const params = {
      page,
      limit: pageSize,
      search: search || undefined,
    };
    
    switch(value) {
      case 0:
        getNoShippingOrders(params);
        break;
      case 1:
        getLateDeliveryOrders(params);
        break;
      case 2:
        getLateFulfillmentOrders(params);
        break;
      default:
        getNoShippingOrders(params);
    }
  }, [page, pageSize, value]);

  const handleSearch = () => {
    setPage(1);
    const params = {
      page: 1,
      limit: pageSize,
      search: search || undefined,
    };
    
    switch(value) {
      case 0:
        getNoShippingOrders(params);
        break;
      case 1:
        getLateDeliveryOrders(params);
        break;
      case 2:
        getLateFulfillmentOrders(params);
        break;
      default:
        getNoShippingOrders(params);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setPage(1);
  };

  const getCurrentData = () => {
    switch(value) {
      case 0:
        return ordersWithoutShipping;
      case 1:
        return lateDeliveryOrders;
      case 2:
        return lateOrders;
      default:
        return ordersWithoutShipping;
    }
  };

  const handleCancelOrder = (orderId) => {
    setSelectedOrderId(orderId);
    setIsModalOpen(true);
  };

  const handleConfirmCancel = () => {
    cancelOrder({ orderId: selectedOrderId });
    setIsModalOpen(false);
    setSelectedOrderId(null);
  };

  const handleCancelModal = () => {
    setIsModalOpen(false);
    setSelectedOrderId(null);
  };

  const handleShowIssues = (order) => {
    setSelectedOrderIssues(order);
    setIsIssuesModalOpen(true);
  };

  const handleCloseIssuesModal = () => {
    setIsIssuesModalOpen(false);
    setSelectedOrderIssues(null);
  };

  const mobileColumns = [
    {
      title: t('orders.orderNumber'),
      dataIndex: 'shopifyOrderNumber',
    },
    {
      title: t('orders.customerName'),
      dataIndex: 'customer',
    },
    {
      title: t('common.status'),
      dataIndex: 'status',
      render: (_, { status }) => status.toUpperCase()
    },
    {
      title: t('common.actions'),
      render: (_, { _id, bostaExceptions }) => (
        <Space direction={isMobile ? "vertical" : "horizontal"} wrap>
          {(value === 0) && (<>
            <Button
              size="small"
              sx={{ ...main_button, textTransform: "none", py: 0.5, px: 1, fontSize: "0.75rem", width: isMobile ? '100%' : 'auto' }}
              onClick={() => navigate(`/orders/fulfillment/${_id}`)}
            >
              {t('actionCenter.editShipping') || 'Edit Shipping'}
            </Button>
            <Button
              size="small"
              sx={{ ...main_button, backgroundColor: 'var(--errorColor)', textTransform: "none", py: 0.5, px: 1, fontSize: "0.75rem", width: isMobile ? '100%' : 'auto' }}
              onClick={() => handleCancelOrder(_id)}
            >
              {t('orders.cancelOrder')}
            </Button>
          </>)}
          {value === 1 && bostaExceptions && bostaExceptions.length > 0 && (
            <Button
              size="small"
              sx={{ ...main_button, backgroundColor: 'var(--warningColor)', textTransform: "none", py: 0.5, px: 1, fontSize: "0.75rem", width: isMobile ? '100%' : 'auto' }}
              onClick={() => handleShowIssues({ _id, bostaExceptions })}
              startIcon={<Warning />}
            >
              {t('actionCenter.issues')}
            </Button>
          )}
        </Space>
      )
    },
  ];

  const columns = [
    {
      title: t('orders.orderNumber'),
      dataIndex: 'shopifyOrderNumber',
    },
    {
      title: t('orders.trackingId'),
      dataIndex: 'trackingId',
    },
    {
      title: t('fulfillment.courier'),
      dataIndex: 'courier',
    },
    {
      title: t('orders.orderDate'),
      dataIndex: 'date',
      sorter: (a, b) => { return moment(a.date).isBefore(b.date) ? -1 : 1 },
    },
    {
      title: t('orders.dateFulfilled'),
      dataIndex: 'dateFulfilled',
      sorter: (a, b) => { return moment(a.dateFulfilled).isBefore(b.dateFulfilled) ? -1 : 1 },
    },
    {
      title: t('orders.dateDelivered'),
      dataIndex: 'dateDelivered',
      sorter: (a, b) => { return moment(a.dateDelivered).isBefore(b.dateDelivered) ? -1 : 1 },
    },
    {
      title: t('orders.customerName'),
      dataIndex: 'customer',
    },
    {
      title: t('actionCenter.customerMobile') || 'Customer Mobile',
      dataIndex: 'phone',
    },
    {
      title: t('actionCenter.orderPrice') || 'Order Price',
      dataIndex: 'price',
      render: (_, { price }) => `${price} EGP`,
      sorter: (a, b) => { return a.price - b.price },
    },
    {
      title: t('common.status'),
      dataIndex: 'status',
      render: (_, { status }) => status.toUpperCase()
    },
    {
      title: t('common.actions'),
      render: (_, { _id, bostaExceptions }) => (
        <Space wrap>
          {(value === 0) && (<>
            <Button
              size="small"
              sx={{ ...main_button, textTransform: "none", py: 0.5, px: 1, fontSize: "0.75rem" }}
              onClick={() => navigate(`/orders/fulfillment/${_id}`)}
            >
              {t('actionCenter.editShippingInfo') || 'Edit Shipping Info'}
            </Button>
            <Button
              size="small"
              sx={{ ...main_button, backgroundColor: 'var(--errorColor)', textTransform: "none", py: 0.5, px: 1, fontSize: "0.75rem" }}
              onClick={() => handleCancelOrder(_id)}
            >
              {t('orders.cancelOrder')}
            </Button>
          </>)}
          {value === 1 && bostaExceptions && bostaExceptions.length > 0 && (
            <Button
              size="small"
              sx={{ ...main_button, backgroundColor: 'var(--warningColor)', textTransform: "none", py: 0.5, px: 1, fontSize: "0.75rem" }}
              onClick={() => handleShowIssues({ _id, bostaExceptions })}
              startIcon={<Warning />}
            >
              {t('actionCenter.viewIssues')}
            </Button>
          )}
        </Space>
      )
    },
  ];

  const data = getCurrentData()?.docs?.map((row) => {
    return {
      _id: row._id,
      shopifyOrderNumber: row.shopifyOrderNumber,
      trackingId: getOrderTrackingId(row),
      courier: getOrderCourierLabel(row, user?.vendor),
      date: moment(row.createdAt).format("lll"),
      dateFulfilled: row.preparedAt ? moment(row.preparedAt).format("lll") : null,
      dateDelivered: row.deliveredAt ? moment(row.deliveredAt).format("lll") : null,
      status: row.fulfillment ? row.status : row.status === "Cancelled" ? "Cancelled" : "INVALID",
      customer: row.fulfillment?.customer,
      phone: row.fulfillment?.phone,
      price: row.fulfillment?.price,
      bostaExceptions: row.bostaExceptions,
    }
  });

  const expandedRowRender = (record) => {
    const columns = [
      {
        title: t('orders.trackingId'),
        dataIndex: 'trackingId',
      },
      {
        title: t('fulfillment.courier'),
        dataIndex: 'courier',
      },
      {
        title: t('orders.ordered'),
        dataIndex: 'date',
      },
      {
        title: t('orders.fulfilled'),
        dataIndex: 'dateFulfilled',
      },
      {
        title: t('orders.delivered'),
        dataIndex: 'dateDelivered',
      },
      {
        title: t('common.phone'),
        dataIndex: 'phone',
      },
      {
        title: t('common.price'),
        dataIndex: 'price',
        render: (_, { price }) => `${price} EGP`,
      },
    ];

    return (
      <Table
        columns={columns}
        dataSource={[record]}
        pagination={false}
        showHeader={!isMobile}
      />
    );
  };

  return (
    <div>
      <Box sx={{ width: "100%", paddingX: isMobile ? 2 : 5 }}>
        <Box sx={{ 
          borderBottom: 1, 
          borderColor: 'divider',
          '& .MuiTabs-root': {
            minHeight: '48px',
          },
          '& .MuiTab-root': {
            color: 'var(--secColor4)',
            textTransform: 'none',
            fontWeight: 500,
            fontSize: isMobile ? '0.9rem' : '1rem',
            minHeight: '48px',
            '&.Mui-selected': {
              color: 'var(--primaryColor)',
              fontWeight: 600,
            },
            '&:hover': {
              color: 'var(--primaryColor)',
              opacity: 0.8,
            },
          },
          '& .MuiTabs-indicator': {
            backgroundColor: 'var(--primaryColor)',
            height: '3px',
          },
        }}>
          <Tabs value={value} onChange={handleChange} aria-label="action center tabs">
            <Tab label={t('actionCenter.ordersWithoutShipping')} />
            <Tab label={t('actionCenter.lateDeliveryOrders')} />
            <Tab label={t('actionCenter.lateFulfillment')} />
          </Tabs>
        </Box>

        <SearchFilterBar
          placeholder={t('orders.searchPlaceholder')}
          value={search}
          onChange={setSearch}
          onSearch={handleSearch}
          isMobile={isMobile}
        />

        <Box sx={{
          width: "100%",
          overflowX: "auto",
          "& .ant-table-wrapper": {
            width: "100%"
          },
          "& .ant-table": {
            minWidth: isMobile ? 300 : 1200
          },
          "& .ant-table-cell": {
            whiteSpace: isMobile ? "normal" : "nowrap"
          }
        }}>
          <Table
            columns={isMobile ? mobileColumns : columns}
            dataSource={data}
            loading={isLoading}
            expandable={{
              expandedRowRender: isMobile ? expandedRowRender : undefined
            }}
            pagination={{
              current: page,
              pageSize: pageSize,
              total: getCurrentData()?.totalDocs,
              showSizeChanger: false,
              showQuickJumper: false,
              showTotal: (total) => `${t('table.total')} ${total} ${t('table.items')}`,
            }}
            onChange={(pagination) => {
              setPage(pagination.current);
              setPageSize(pagination.pageSize);
            }}
            showSorterTooltip={{
              target: 'sorter-icon',
            }}
            scroll={{ x: isMobile ? 300 : 1200 }}
          />
        </Box>
      </Box>
      <Modal
        title={<Typography sx={{ color: 'var(--secColor4)', fontSize: '1.2rem', fontWeight: 600 }}>{t('actionCenter.confirmCancellation') || 'Confirm Order Cancellation'}</Typography>}
        open={isModalOpen}
        onOk={handleConfirmCancel}
        onCancel={handleCancelModal}
        okText={t('actionCenter.yesCancelOrder') || 'Yes, Cancel Order'}
        cancelText={t('actionCenter.noKeepOrder') || 'No, Keep Order'}
        okButtonProps={{ danger: true }}
        styles={{
          mask: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)'
          },
          content: {
            backgroundColor: 'var(--appBg)',
            color: 'var(--secColor4)'
          },
          header: {
            backgroundColor: 'var(--appBg)',
            color: 'var(--secColor4)',
            borderBottom: '1px solid var(--secColor1)'
          },
          body: {
            backgroundColor: 'var(--appBg)',
            color: 'var(--secColor4)'
          },
          footer: {
            backgroundColor: 'var(--appBg)',
            borderTop: '1px solid var(--secColor1)',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '8px',
            padding: '16px'
          }
        }}
        footer={[
          <Button
            key="cancel"
            onClick={handleCancelModal}
            sx={{ ...main_button }}
          >
            {t('actionCenter.noKeepOrder') || 'No, Keep Order'}
          </Button>,
          <Button
            key="confirm"
            onClick={handleConfirmCancel}
            sx={{ ...main_button, backgroundColor: 'var(--errorColor)' }}
          >
            {t('actionCenter.yesCancelOrder') || 'Yes, Cancel Order'}
          </Button>
        ]}
      >
        <p style={{ color: 'var(--secColor4)' }}>{t('orders.cancelOrderConfirm')}</p>
      </Modal>

      <Modal
        title={<Typography sx={{ color: 'var(--secColor4)', fontSize: '1.2rem', fontWeight: 600 }}>{t('actionCenter.shippingIssues') || 'Shipping Issues'}</Typography>}
        open={isIssuesModalOpen}
        onCancel={handleCloseIssuesModal}
        footer={[
          <Button
            key="close"
            onClick={handleCloseIssuesModal}
            sx={{ ...main_button }}
          >
            {t('common.close')}
          </Button>
        ]}
        width={800}
        styles={{
          mask: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)'
          },
          content: {
            backgroundColor: 'var(--appBg)',
            color: 'var(--secColor4)'
          },
          header: {
            backgroundColor: 'var(--appBg)',
            color: 'var(--secColor4)',
            borderBottom: '1px solid var(--secColor1)'
          },
          body: {
            backgroundColor: 'var(--appBg)',
            color: 'var(--secColor4)'
          },
          footer: {
            backgroundColor: 'var(--appBg)',
            borderTop: '1px solid var(--secColor1)',
            display: 'flex',
            justifyContent: 'flex-end',
            padding: '16px'
          }
        }}
      >
        {selectedOrderIssues && (
          <Box sx={{ p: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={2}>
                <Typography fontWeight={"bold"} sx={{ color: 'var(--secColor4)' }}>ID</Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography fontWeight={"bold"} sx={{ color: 'var(--secColor4)' }}>Issue</Typography>
              </Grid>
              {selectedOrderIssues.bostaExceptions.map((reason, idx) => {
                return (
                  <React.Fragment key={idx}>
                    <Grid item xs={2}>
                      <Typography sx={{ color: 'var(--secColor4)' }}>{idx + 1}</Typography>
                    </Grid>
                    <Grid item xs={10}>
                      <Typography sx={{ color: 'var(--secColor4)' }}>
                        {reason.reason 
                          ? `[${moment(reason.date).format("DD-MM-YYYY HH:mm")}]: ${reason.reason}`
                          : reason}
                      </Typography>
                    </Grid>
                  </React.Fragment>
                );
              })}
            </Grid>
          </Box>
        )}
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state?.auth?.user,
  isLoading: state?.records?.isLoading,
  ordersWithoutShipping: state?.records?.ordersWithoutShipping,
  lateDeliveryOrders: state?.records?.lateDeliveryOrders,
  lateOrders: state?.records?.lateOrders,
});

const mapDispatchToProps = { 
  getNoShippingOrders,
  getLateDeliveryOrders,
  getLateFulfillmentOrders,
  cancelOrder
};

export default connect(mapStateToProps, mapDispatchToProps)(ActionCenter);
